import { debug } from "../utils";

export const ACTION_AUTH_TOKEN_CHANGED = "ACTION_AUTH_TOKEN_CHANGED";
export const ACTION_REFERER_PAGE_ADDED = "ACTION_REFERER_PAGE_ADDED";
// export const ACTION_AUTH_USER_CAPABILITY = "ACTION_AUTH_USER_CAPABILITY";


export function AuthReducer(state = {}, action) {
    switch (action.type) {
        case ACTION_AUTH_TOKEN_CHANGED: {
            debug(`AuthReducer ${ACTION_AUTH_TOKEN_CHANGED} is being processed...`, state, action)
            return {
                ...state,
                referer: state.referer,
                ...action.payload
            }
        }
        // case ACTION_AUTH_USER_CAPABILITY: {
        //     debug(`AuthReducer ${ACTION_AUTH_USER_CAPABILITY} is being processed...`, state, action)
        //     return {
        //         ...state,
        //         referer: state.referer,
        //         ...action.payload
        //     }
        // }
        case ACTION_REFERER_PAGE_ADDED: {
            debug(`AuthReducer ${ACTION_REFERER_PAGE_ADDED} is being processed...`, state, action)
            return {
                ...state,
                referer: action.payload.referer
            }
        }
        default:
            return state;
    }
}